import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

/** Google redirects back here with ?code=… — trade it for a session, then continue. */
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    (async () => {
      if (params.get("error") || !code) {
        setError("Sign-in was cancelled.");
        setTimeout(() => navigate("/", { replace: true }), 1800);
        return;
      }
      try {
        await api.post("/auth/google", { code, redirect_uri: `${window.location.origin}/auth/google` });
        // full navigation: the session cookie is set, so My Account loads clean and
        // smooth-scroll re-initialises instead of inheriting the callback screen's state
        window.location.replace("/my-library");
      } catch (e) {
        console.error("Google sign-in failed", e);
        const blocked = e.response?.status === 403 && e.response?.data?.detail;
        setError(blocked || "We couldn't complete sign-in. Please try again.");
        setTimeout(() => navigate("/", { replace: true }), blocked ? 6000 : 2400);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-ink px-6" data-testid="auth-callback">
      <p className="overline text-crimson mb-4">One moment</p>
      <p className="font-serif text-3xl text-vellum text-center animate-pulse max-w-xl leading-snug" data-testid="auth-callback-status">
        {error || "Entering the archive…"}
      </p>
    </div>
  );
}
